//@ts-nocheck
import React from 'react'
import {Unit, unitInitValues} from '../../../../../_metronic/helpers'
import Swal from 'sweetalert2'

import {Field, Form, Formik} from 'formik'
import {unitValidationSchema} from '../core/init'
import {createUnits} from '../../../settings/preferences/GlobalParams/core/requests'

interface DialogProps {
  onDismiss: () => void
  onSave: () => void
  refreshData: () => void
  onNewUnit: (unit: any) => void
}

const CreateUnitModal: React.FC<DialogProps> = ({onDismiss, refreshData, onSave, onNewUnit}) => {
  const formValues: Unit = {
    label: unitInitValues.label || '',
    code: unitInitValues.code || '',
  }
  // const handleSave = async (values: Unit) => {
  //   console.log('values', values)
  //   await createUnits(values)
  //   onSave()
  //   onDismiss()
  // }
  const handleSave = async (values: Unit) => {
    try {
      const isValid = await unitValidationSchema.isValid(values)
      if (!isValid) {
        const validationErrors = await unitValidationSchema
          .validate(values, {abortEarly: false})
          .catch((err) => err.inner)
        const formErrors = validationErrors.reduce((acc, curr) => {
          acc[curr.path] = curr.message
          return acc
        }, {})
        setErrors(formErrors)
        // setSubmitting(false)
        return
      }
      await createUnits(values)
      onNewUnit(values)
      onSave()
      onDismiss()
    } catch (error) {
      console.error('Form submission error', error)
      Swal.fire({
        icon: 'error',
        title: 'Erreur!',
        text: 'Le libellé est requis',
      })
    } finally {
      console.log('Form submission')
      // setSubmitting(false)
    }
  }

  return (
    <>
      <div
        className='modal fade show d-block'
        id='modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        <div className='modal-dialog modal-dialog-centered'>
          <div className='modal-content'>
            <form noValidate className='ng-pristine ng-invalid ng-touched'>
              <div className='modal-header'>
                <div className='card-title mt-0 fw-bold fs-5'>Ajouter Unité</div>
              </div>
              <div className='modal-body'>
                <Formik
                  id='modal_add_user_form'
                  initialValues={formValues}
                  onSubmit={handleSave}
                  validationSchema={unitValidationSchema}
                >
                  {({touched, errors, isValid, values}) => (
                    <Form>
                      {/* <div className='form-group row mb-2'>
                        <label className=' col-3 required fw-semibold fs-6 mb-2'>Label</label>
                        <div className='col-9'>
                          <Field
                            label='label'
                            className='form-control d mb-3 mb-lg-0'
                            type='text'
                            // className='form-control'
                          />
                          {touched.label && errors.label && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.label}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div> */}
                      <div className='form-group row mb-2'>
                        <label className=' col-3 required fw-semibold fs-6 mb-2'>Label</label>
                        <div className='col-9'>
                          <Field
                            name='label'
                            className='form-control d mb-3 mb-lg-0'
                            type='text'
                            // className='form-control'
                          />
                          {touched.label && errors.label && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.label}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className='form-group row mb-2'>
                        <label className=' col-3 required fw-semibold fs-6 mb-2'>Code</label>
                        <div className='col-9'>
                          <Field
                            name='code'
                            className='form-control d mb-3 mb-lg-0'
                            type='text'
                            // className='form-control'
                          />
                          {touched.code && errors.code && (
                            <div className='fv-plugins-message-container'>
                              <div className='fv-help-block'>
                                <span role='alert'>{errors.code}</span>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className='modal-footer pe-0 mt-3'>
                        <button
                          type='button'
                          onClick={onDismiss}
                          className='btn btn-outline-secondary mr-5'
                        >
                          <i className='fas fa-arrow-left'></i> Annuler
                        </button>
                        <button
                          type='button'
                          onClick={() => handleSave(values)}
                          className='btn btn-primary ml-5 pl-5'
                        >
                          <i className='fas fa-save'></i> Enregistrer
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  )
}

export default CreateUnitModal
